//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import { APP_DATE_DOT_FORMAT_AM_PM } from "@/assets/js/appConfig";
import { setPluginIcon, convertAndFormatTimeToLocal } from "@/assets/js/appFunc";
import { mapActions } from "vuex";
import CompareJson from "./CompareJson/CompareJson.vue";

export default {
    name: "TimelineDataModel",
    components: {
        AQModal,
        AQTooltip,
        CompareJson,
        AQChip
    },
    filters: {
        dateFormatter(dateToFormat) {
            let dataToReturn = "";
            if (dateToFormat) {
                const newData = convertAndFormatTimeToLocal(dateToFormat, APP_DATE_DOT_FORMAT_AM_PM).split(" ");
                if (newData) {
                    dataToReturn = `${newData[0]} at ${newData[1]} ${newData[2]}`;
                }
            }
            return dataToReturn;
        }
    },
    props: {
        value: {
            type: String,
            default: ""
        },
        parentTaskDetails: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            hasPluginType: false,
            modalValue: false,
            activity: {
                pluginType: ""
            },
            primaryBtn: {
                label: this.$t("generic.done")
            },
            oldData: {},
            newData: {},
            changes: { updated: 0, added: 0, deleted: 0 },
            dataAudit: {}
        };
    },
    computed: {
        getUserName() {
            let name = "";
            if (this.dataAudit && this.dataAudit.userSimpleDto) {
                const { firstName, lastName, username } = this.dataAudit.userSimpleDto;
                if (firstName) {
                    name = firstName;
                }
                if (lastName) {
                    name = `${name} ${lastName}`.trim();
                }
                if (!name) {
                    name = username;
                }
            }
            return name;
        },
        getNrChanges() {
            const allNrChanges = this.changes.added + this.changes.deleted + this.changes.updated;
            return allNrChanges;
        },
        isSmallScreen() {
            return localStorage.getItem("localIsSmallScreen") || false;
        },
        getDataAuditChanges() {
            const edited = this.changes.updated ? `${this.changes.updated} ${this.$t("timeline.edited")}` : "";
            const removed = this.changes.deleted ? `${this.changes.deleted} ${this.$t("timeline.removed")}` : "";
            const added = this.changes.added ? `${this.changes.added} ${this.$t("timeline.added")}` : "";

            return edited + (removed && edited ? `, ${removed}` : removed) + (added && (edited || removed) ? `, ${added}` : added);
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.modalValue = !!newValue;
            },
            immediate: true
        }
    },
    created() {
        this.getData();
        if (this.parentTaskDetails && this.parentTaskDetails.type) {
            this.activity.pluginType = this.parentTaskDetails.type;
            this.hasPluginType = !!this.setPluginIcon(this.activity);
        }
    },
    methods: {
        ...mapActions("diagrams", ["getDataAuditTimeline"]),
        setPluginIcon,
        convertAndFormatTimeToLocal,
        setChanges(data) {
            this.changes = data;
        },
        getData() {
            this.getDataAuditTimeline(this.value).then(
                data => {
                    const response = data.data; const oldData = {}; const
                        newData = {};

                    this.dataAudit = response;

                    response.previousData.forEach(element => {
                        const { type } = element;
                        oldData[type] = JSON.parse(element.fields);
                    });
                    response.currentData.forEach(element => {
                        const { type } = element;
                        newData[type] = JSON.parse(element.fields);
                    });
                    this.oldData = oldData;
                    this.newData = newData;
                },
                () => {
                    this.$toast.showNotify({
                        message: this.$t("generic.errors"),
                        type: "error"
                    });
                }
            );
        },
        getChipProps(user) {
            let typeToReturn = "user";
            if (user) {
                const { status } = user;
                if (user.lastName && (user.lastName === "System" || user.lastName === null)) {
                    typeToReturn = "default";
                } else if (status === "DISABLED") {
                    typeToReturn = "disabledUser";
                }
            }
            return {
                type: typeToReturn,
                content: this.getUserName
            };
        },
        actions() {
            this.$emit("input");
        }
    }
};
